export const formattedDateToNumericPT = (date) => {
	if (!date) return null

	let convertDate = new Date(date).toISOString().substring(0, 10)

	convertDate = new Date(convertDate).toLocaleDateString("pt-BR", { timeZone: "UTC" })

	return convertDate
}

export const formatMsToTimer = (milliseconds) => {
	const seconds = Math.trunc((milliseconds / 1000) % 60);
	const minutes = Math.trunc(((milliseconds / (1000 * 60)) % 60));
	const hours = Math.trunc(((milliseconds / (1000 * 60 * 60)) % 24));

	return ('00' + hours).slice(-2) + ':' + ('00' + minutes).slice(-2) + ':' + ('00' + seconds).slice(-2)
}